import { C } from "./UI";

// Custom SVG icons for social media (lucide-react removed these)
const InstagramIcon = ({ size = 16, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

const FacebookIcon = ({ size = 16, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const LinkedinIcon = ({ size = 16, strokeWidth = 1.5 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const SOCIAL_LINKS = [
  {
    name: "Instagram",
    icon: InstagramIcon,
    url: "https://www.instagram.com/_womom_?igsh=MTBweWM2N2ZpZ3Fqbw==",
  },
  {
    name: "Facebook",
    icon: FacebookIcon,
    url: "https://www.facebook.com/profile.php?id=61568228163076",
  },
  {
    name: "LinkedIn",
    icon: LinkedinIcon,
    url: "https://www.linkedin.com/company/womom-brasil/?viewAsMember=true",
  },
];

export default function Footer() {
  return (
    <footer
      style={{
        padding: "28px 80px",
        borderTop: `0.5px solid ${C.border}`,
        background: C.surface,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 20,
        }}
      >
        {/* Logo */}
        <a href="/" style={{ display: "flex", alignItems: "center" }}>
          <img 
            src="/images/logo-womom.png" 
            alt="WoMom" 
            style={{ 
              height: 192,
              width: "auto",
              objectFit: "contain"
            }} 
          />
        </a>

        {/* Center: Copyright + Social Icons */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 24,
          }}
        >
          <p style={{ fontSize: 12, color: C.textSec, margin: 0 }}>
            © 2025 WoMom · Todos os direitos reservados
          </p>

          {/* Social Icons */}
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            {SOCIAL_LINKS.map(({ name, icon: Icon, url }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: C.rosePale,
                  color: C.roseMid,
                  transition: "all 0.2s ease",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = C.roseMid;
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = C.rosePale;
                  e.currentTarget.style.color = C.roseMid;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        {/* Right: Links */}
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          {["Privacidade", "Termos"].map((l) => (
            <span
              key={l}
              style={{
                fontSize: 12,
                color: C.textSec,
                cursor: "pointer",
                transition: "color 0.15s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = C.roseMid)}
              onMouseLeave={(e) => (e.currentTarget.style.color = C.textSec)}
            >
              {l}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}
